import React, { useState } from 'react'
import BodewrkLogo from '../../assets/imgs/bodewrk-logo.png'
import InstagramIcon from '../../assets/imgs/instagram-icon.png'
import TwitterIcon from '../../assets/imgs/twitter-footer-icon.png'
import FacebookIcon from '../../assets/imgs/facebook-footer-icon.png'
import TermsAndConditionsModal from '../../modals/TermsAndConditionsModal'
import FrequentlyAskedQuestionsModal from '../../modals/FrequentlyAskedQuestionsModal'

const ClientFooter = () => {
  const [
    isTermsAndConiditionsModalOpen,
    setIsTermsAndConiditionsModalOpen,
  ] = useState(false)
  const [isFAQModalOpen, setIsFAQModalOpen] = useState(false)
  const handleTermsAndConditionsModal = () => {
    setIsTermsAndConiditionsModalOpen((prev) => !prev)
  }
  const handleFAQModal = () => {
    setIsFAQModalOpen((prev) => !prev)
  }
  return (
    <div className="client-footer">
      <div className="container py-5">
        <div className="row">
          <div className="col-12 col-sm-12 col-md-5">
            <div>
              <div className="d-flex align-items-center">
                <img
                  src={BodewrkLogo}
                  alt="Bodewrk Logo"
                  height={104}
                  width={177}
                />
                <h1
                  className="fs-36 bodewrk-logo-title m-0 fw-bold"
                  style={{ color: '#2597F6' }}
                >
                  BODEWRK
                </h1>
              </div>
              <p className="fs-24 font-weight-bold mt-4">TALK TO US</p>
              <p className="fs-18 mt-3">Facebook</p>
              <p className="fs-18 mt-3">Twitter</p>
              <p className="fs-18 mt-3">Instagram</p>
              <p className="fs-24 font-weight-bold mt-4">OUR LOCATIONS</p>
              <p className="fs-18 mt-3">Brooklyn, NY</p>
              <p className="fs-18 mt-3">Newark, NJ</p>
            </div>
            <div className="mt-3 d-flex gap-2">
              <img
                src={FacebookIcon}
                alt="Facebook Icon"
                height={52}
                style={{ marginRight: '10px' }}
              />
              <img
                src={TwitterIcon}
                alt="Twitter Icon"
                height={52}
                style={{ marginRight: '10px' }}
              />
              <img
                src={InstagramIcon}
                alt="Instagram Icon"
                height={52}
                style={{ marginRight: '10px' }}
              />
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-7">
            <p
              className="lh-sm footer-highligted-text"
              style={{ fontSize: '48px', color: '#111111' }}
            >
              Get Services When & Where You Want It!
            </p>
            <div className="footer-links-text">
              <p className="fw-bold fs-24 mt-5">ABOUT US</p>
              <p
                className="fw-bold fs-24 mt-3 pointer"
                onClick={handleFAQModal}
              >
                FAQ
              </p>
              <p
                className="fw-bold fs-24 mt-3 pointer"
                onClick={handleTermsAndConditionsModal}
              >
                TERMS & CONDITIONS
              </p>
              <p className="fw-bold fs-24 mt-3">POLICIES</p>
            </div>
            <p
              className="fs-24 fw-bold mt-5"
              style={{ marginTop: '7rem !important' }}
            >
              Support@BodeWrk.com
            </p>
          </div>
        </div>
      </div>
      {isTermsAndConiditionsModalOpen && (
        <TermsAndConditionsModal
          handleTermsAndConditionsModal={handleTermsAndConditionsModal}
          modalOpen={isTermsAndConiditionsModalOpen}
          screen={'client-footer'}
        />
      )}
      {isFAQModalOpen && (
        <FrequentlyAskedQuestionsModal
          handleFrequentlyAskedQuestionsModal={handleFAQModal}
          modalOpen={isFAQModalOpen}
          screen="client-footer"
        />
      )}
    </div>
  )
}

export default ClientFooter
